export default __webpack_public_path__ + "static/media/pop-grey.fe1f3a21.svg";